const VolumeTransactions = {
    data() {
        return {
            modoPegadoActivo: false,
            tipoPegado: null,
            servicioSeleccionado: null,
            servicio: null,
            tipoEscenario: 'transacciones',
            escenarioPersonalizado: null,
            ventanas: [],
            intervalosPorDia: {}, // ← nuevo agrupamiento por día
            diasDisponibles: [],
            servicios: [],
            intervalos: [],
            snackbar: {
                visible: false,
                text: ''
            },
            items: [],
            headersEsc: [
                { text: 'Servicio', value: 'servicio_id' },
                { text: 'Tipo', value: 'tipo' },
                { text: 'Nombre Escenario', value: 'nombre' },
                { text: 'Acciones', value: 'acciones', sortable: false }
            ],
            tipo_escenario: [
                { text: 'Transacciones Entrantes', value: 'transacciones' },
                { text: 'Transacciones Salientes', value: 'horas' },
                { text: 'Agentes', value: 'agentes' }
            ],
            escenarios: [],
            matrizEscenarios: [],
            headersMatriz: [],
            diasMatriz: [],
            dialogDetalle: {
                visible: false,
                servicio_id: null,
                tipo: null,
                nombre: null
            },
            dialogEliminar: {
                visible: false,
                servicio_id: null,
                tipo: null,
                nombre: ''
            },
            cargando: false,
            cargandoEscenario: false,
            tmgGeneral: null

        };
    },
    mounted() {
        this.cargarServicios();
        this.cargarEscenariosData();
    },
    computed: {
        esEscenarioAgentes() {
            return this.tipoEscenario === 'agentes';
        },
        headers() {
            const dias = this.ventanas.map(v => v.dia_semana);
            const baseHeaders = [{ text: 'Intervalo', value: 'texto', sortable: false }];

            const esEscenarioAgentes = this.tipoEscenario === 'agentes';

            const volumenYTmgHeaders = [];

            dias.forEach(dia => {
                const volumenText = esEscenarioAgentes ? `Agentes (${dia})` : `Volumen (${dia})`;
                volumenYTmgHeaders.push({
                    text: volumenText,
                    value: `volumen_${dia}`,
                    sortable: false,
                    class: 'celda-volumen'
                });

                if (!esEscenarioAgentes) {
                    volumenYTmgHeaders.push({
                        text: `TMG (${dia})`,
                        value: `tmg_${dia}`,
                        sortable: false,
                        class: 'celda-tmg'
                    });
                }
            });

            return [...baseHeaders, ...volumenYTmgHeaders];
        },
        nombreEscenario: {
            get() {
                if (this.escenarioPersonalizado) {
                    return this.escenarioPersonalizado;
                }

                const servicio = this.servicios.find(s => s.id === this.servicioSeleccionado)?.nombre || 'Servicio';
                const tipo = this.tipo_escenario.find(t => t.value === this.tipoEscenario)?.text || 'Escenario';

                return `Escenario ${tipo} - ${servicio}`;
            },

            set(value) {
                this.escenarioPersonalizado = value;
            }
        },
        tituloSemana() {
            let fecha = this.$store.state.fechaEscenario || this.fechaSeleccionada;

            if (!fecha) {
                fecha = new Date();
            }

            const numeroSemana = this.obtenerNumeroSemana(fecha);
            const año = new Date(fecha).getFullYear();

            return `- Semana ${numeroSemana} (${año})`;
        }
    },
    watch: {
        servicioSeleccionado(val) {
            if (val) {
                this.cargarVentanaServicio();
            }
        }
    },
    methods: {
        activarPegar(tipo) {
            this.tipoPegado = tipo;
            this.modoPegadoActivo = true;
        },
        async cargarServicios() {
            try {
                const usuarioId = this.$store.state.id;
                const res = await this.$axios.get(`list-services?usuario=${usuarioId}`);
                this.servicios = res.data;
            } catch (err) {
                console.error('Error al cargar servicios:', err);
                this.$toast.error('No se pudieron cargar los servicios');
            }

        },
        async cargarVentanaServicio() {
            const res = await this.$axios.get(`ventana-servicio/${this.servicioSeleccionado}`);
            this.ventanas = res.data;
            this.diasDisponibles = res.data.map(v => v.dia_semana);
        },
        async cargarEscenariosData() {
            this.cargando = true;
            try {
                const usuarioId = this.$store.state.id;
                const res = await this.$axios.get(`escenario?usuario=${usuarioId}`);
                this.items = res.data;
            } catch (error) {
                console.error(error);
                this.$toast.error('Error de conexión');
            } finally {
                this.cargando = false;
            }

        },
        async verDetalleEscenario(item) {
            this.servicio = item.servicio_id;
            this.tipoEscenario = item.tipo;
            this.nombre = item.nombre
            try {
                const res = await this.$axios.get(`escenario/${this.servicio}/${this.tipoEscenario}/${this.nombre}`);
                this.escenarios = res.data;
                //console.log(this.escenarios);
                this.dialogDetalle = {
                    visible: true,
                    servicio_id: item.servicio_id,
                    tipo: item.tipo,
                    nombre: item.nombre
                };
                this.generarVistaMatriz(this.escenarios);
            } catch (err) {
                this.$toast.error('Error al cargar el detalle del escenario');
            }
        },
        obtenerNombreServicio(id) {
            const servicio = this.servicios.find(s => s.id === id);
            return servicio ? servicio.nombre : `ID ${id}`;
        },
        obtenerTextoTipoEscenario(value) {
            const tipo = this.tipo_escenario.find(t => t.value === value);
            return tipo ? tipo.text : value;
        },
        async actualizarVolumen(item) {
            try {
                await this.$axios.put('escenario-actualizar', {
                    id: item.id,
                    volumen: item.volumen
                });
                this.$toast.success('Volumen actualizado');
            } catch (e) {
                this.$toast.error('Error al actualizar');
            }
        },
        eliminarEscenario(item) {
            this.dialogEliminar = {
                visible: true,
                servicio_id: item.servicio_id,
                tipo: item.tipo,
                nombre: item.nombre,
            };
            console.log(this.dialogEliminar);
        },
        async confirmarEliminacion() {
            try {
                const { servicio_id, tipo, nombre } = this.dialogEliminar;
                await this.$axios.delete(`escenario-eliminar/${servicio_id}/${tipo}`, {
                    params: {
                        nombre_escenario: nombre // Enviamos el nombre como parámetro de consulta
                    }
                });
                this.$toast.success('Escenario eliminado correctamente');
                this.dialogEliminar.visible = false;
                this.cargarEscenariosData();
            } catch (e) {
                this.$toast.error('Error al eliminar el escenario');
            }
        },
        generarIntervalos() {
            const toMinutes = h => {
                const [hr, min] = h.split(':').map(Number);
                return hr * 60 + min;
            };
            const toTime = m => {
                const hr = Math.floor(m / 60) % 24;
                const min = m % 60;
                return `${String(hr).padStart(2, '0')}:${String(min).padStart(2, '0')}`;
            };

            const ventanas = this.ventanas;
            const Inicio = toMinutes(ventanas[0].hora_apertura);
            let Fin = toMinutes(ventanas[0].hora_cierre);

            if (Fin <= Inicio) {
                Fin += 24 * 60;
            }

            const esEscenarioAgentes = this.tipoEscenario === 'agentes';
            const intervalosUnificados = [];
            for (let m = Inicio; m < Fin; m += 30) {
                const start = toTime(m);
                const end = toTime(m + 30);
                const obj = {
                    texto: `${start} - ${end}`
                };

                for (const v of ventanas) {
                    const dia = v.dia_semana;
                    obj[`volumen_${dia}`] = 0;
                    if (!esEscenarioAgentes) {
                        obj[`tmg_${dia}`] = 320;
                    } else {
                        obj[`tmg_${dia}`] = 0;
                    }
                }

                intervalosUnificados.push(obj);
            }
            this.intervalos = intervalosUnificados;

        },
        async guardarEscenario1() {

            try {
                if (!this.servicioSeleccionado || !this.tipoEscenario) {
                    this.$toast.error('Completa todos los campos obligatorios.');
                    return;
                }

                if (!this.intervalos.length) {
                    this.$toast.error('Genera los intervalos antes de guardar.');
                    return;
                }

                const hayIncompleto = this.intervalos.some(intervalo => {
                    return Object.keys(intervalo)
                        .filter(key => key.startsWith('volumen_'))
                        .some(key => {
                            const valor = intervalo[key];
                            return valor === null || valor === '';
                        });
                });

                if (hayIncompleto) {
                    this.$toast.error('Todos los volúmenes de todos los días deben tener un valor mayor o igual a 0.');
                    return;
                }

                const hayTmgIncompleto = this.intervalos.some(intervalo => {
                    return Object.keys(intervalo)
                        .filter(key => key.startsWith('tmg_'))
                        .some(key => {
                            const valor = intervalo[key];
                            return valor === null || valor === '';
                        });
                });

                if (hayTmgIncompleto) {
                    this.$toast.error('Todos los TMGs de todos los días deben tener un valor.');
                    return;
                }
                this.cargandoEscenario = true;
                const diasSemana = Object.keys(this.intervalos[0])
                    .filter(key => key.startsWith('volumen_'))
                    .map(key => key.replace('volumen_', ''));

                const escenarios = [];

                diasSemana.forEach(dia => {
                    this.intervalos.forEach(intervalo => {
                        const volumen = intervalo[`volumen_${dia}`];
                        const tmg = intervalo[`tmg_${dia}`];

                        const [inicio, fin] = intervalo.texto.split(' - ');
                        escenarios.push({
                            dia,
                            intervalo_inicio: inicio,
                            intervalo_fin: fin,
                            volumen,
                            tmg: tmg
                        });
                    });
                });

                const payload = {
                    servicio_id: this.servicioSeleccionado,
                    tipo: this.tipoEscenario,
                    nombre: this.nombreEscenario,
                    escenarios
                };

                const res = await this.$axios.post('escenario', payload);
                if (res.data.status === 'ok') {
                    this.snackbar.text = 'Escenario guardado correctamente';
                    this.snackbar.visible = true;
                    this.cargandoEscenario = false;
                    this.cargarEscenariosData();
                    this.resetFormulario();
                } else {
                    const nombreServicio = this.obtenerNombreServicio(payload.servicio_id);
                    const mensaje = res.data.message.replace(payload.servicio_id, nombreServicio);
                    this.$toast.error(mensaje);
                    this.cargandoEscenario = false;
                }
            } catch (err) {
                console.error(err);
                this.$toast.error('Error de conexión');
            }
        },

        async guardarEscenario() {
            try {
                if (!this.servicioSeleccionado || !this.tipoEscenario) {
                    this.$toast.error('Completa todos los campos obligatorios.');
                    return;
                }

                if (!this.intervalos.length) {
                    this.$toast.error('Genera los intervalos antes de guardar.');
                    return;
                }

                // Función auxiliar para validar y convertir a flotante real
                const aNumeroValido = (val) => {
                    if (val === null || val === undefined || val === '') return NaN;
                    const str = String(val).replace(',', '.');
                    return parseFloat(str);
                };

                // 1. Validar volúmenes
                const hayIncompleto = this.intervalos.some(intervalo => {
                    return Object.keys(intervalo)
                        .filter(key => key.startsWith('volumen_'))
                        .some(key => {
                            const num = aNumeroValido(intervalo[key]);
                            return isNaN(num) || num < 0;
                        });
                });

                if (hayIncompleto) {
                    this.$toast.error('Todos los volúmenes de todos los días deben tener un valor mayor o igual a 0.');
                    return;
                }

                // 2. Validar TMGs
                const hayTmgIncompleto = this.intervalos.some(intervalo => {
                    return Object.keys(intervalo)
                        .filter(key => key.startsWith('tmg_'))
                        .some(key => {
                            const num = aNumeroValido(intervalo[key]);
                            return isNaN(num);
                        });
                });

                if (hayTmgIncompleto) {
                    this.$toast.error('Todos los TMGs de todos los días deben tener un valor.');
                    return;
                }

                this.cargandoEscenario = true;

                const diasSemana = Object.keys(this.intervalos[0])
                    .filter(key => key.startsWith('volumen_'))
                    .map(key => key.replace('volumen_', ''));

                const escenarios = [];

                // 3. Mapeo garantizando envío numérico en JSON
                diasSemana.forEach(dia => {
                    this.intervalos.forEach(intervalo => {
                        const volumen = aNumeroValido(intervalo[`volumen_${dia}`]);
                        const tmg = aNumeroValido(intervalo[`tmg_${dia}`]);

                        const [inicio, fin] = intervalo.texto.split(' - ');
                        escenarios.push({
                            dia,
                            intervalo_inicio: inicio,
                            intervalo_fin: fin,
                            volumen: isNaN(volumen) ? 0 : volumen,
                            tmg: isNaN(tmg) ? 0 : tmg
                        });
                    });
                });

                const payload = {
                    servicio_id: this.servicioSeleccionado,
                    tipo: this.tipoEscenario,
                    nombre: this.nombreEscenario,
                    escenarios
                };

                // Imprime en consola para inspeccionar exactamente qué enviará Axios
                console.log('Payload procesado:', payload);

                const res = await this.$axios.post('escenario', payload);
                if (res.data.status === 'ok') {
                    this.snackbar.text = 'Escenario guardado correctamente';
                    this.snackbar.visible = true;
                    this.cargandoEscenario = false;
                    this.cargarEscenariosData();
                    this.resetFormulario();
                } else {
                    const nombreServicio = this.obtenerNombreServicio(payload.servicio_id);
                    const mensaje = res.data.message.replace(payload.servicio_id, nombreServicio);
                    this.$toast.error(mensaje);
                    this.cargandoEscenario = false;
                }
            } catch (err) {
                console.error(err);
                this.$toast.error('Error de conexión');
                this.cargandoEscenario = false;
            }
        },
        resetFormulario() {
            this.servicioSeleccionado = null;
            this.tipoEscenario = 'transacciones';
            this.ventanas = [];
            this.intervalos = [];
            this.escenarioPersonalizado = null;
            this.modoPegadoActivo = false
        },
        generarVistaMatriz1(escenarios) {
            const agrupado = {};
            const diasDetectados = new Set();

            const esEscenarioAgentes = this.tipoEscenario === 'agentes';
            escenarios.forEach(e => {
                const intervalo = `${e.intervalo_inicio.slice(0, 5)} - ${e.intervalo_fin.slice(0, 5)}`;
                if (!agrupado[intervalo]) agrupado[intervalo] = { intervalo };

                const diaKeyVolumen = `${e.dia_semana}_vol`;
                const diaKeyTmg = `${e.dia_semana}_tmg`;

                agrupado[intervalo][diaKeyVolumen] = { valor: e.volumen, id: e.id };

                if (!esEscenarioAgentes) {
                    const diaKeyTmg = `${e.dia_semana}_tmg`;
                    agrupado[intervalo][diaKeyTmg] = { valor: e.tmg, id: e.id };
                }

                diasDetectados.add(e.dia_semana);

            });

            const ordenDias = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];

            this.diasMatriz = Array.from(diasDetectados).sort((a, b) => {
                return ordenDias.indexOf(a) - ordenDias.indexOf(b);
            });

            Object.values(agrupado).forEach(row => {
                this.diasMatriz.forEach(dia => {
                    const diaKeyVolumen = `${dia}_vol`;
                    const diaKeyTmg = `${dia}_tmg`;

                    if (!row[diaKeyVolumen]) {
                        row[diaKeyVolumen] = { valor: null, id: null };
                    }
                    if (!esEscenarioAgentes) {
                        const diaKeyTmg = `${dia}_tmg`;
                        if (!row[diaKeyTmg]) {
                            row[diaKeyTmg] = { valor: null, id: null };
                        }
                    }
                });
            });

            this.matrizEscenarios = Object.values(agrupado);

            const headersDinamicos = [];
            const volumenHeaderText = esEscenarioAgentes ? 'Agentes' : 'Vol.';
            this.diasMatriz.forEach(dia => {
                headersDinamicos.push({
                    text: `${volumenHeaderText} (${dia})`,
                    value: `${dia}_vol`,
                    sortable: false
                });
                if (!esEscenarioAgentes) {
                    headersDinamicos.push({
                        text: `TMG (${dia})`,
                        value: `${dia}_tmg`,
                        sortable: false
                    });
                }
            });
            this.headersMatriz = [
                { text: 'Intervalo', value: 'intervalo', sortable: false },
                ...headersDinamicos
            ];

        },
        generarVistaMatriz(escenarios) {
            const agrupado = {};
            const diasDetectados = new Set();

            // Helper para parsear números y eliminar ceros innecesarios a la derecha
            const parsearValorLimpio = (val) => {
                if (val === null || val === undefined || val === '') return null;
                const str = String(val).replace(',', '.');
                const num = parseFloat(str);
                return isNaN(num) ? null : num; // parseFloat remueve automáticamente 805.0000 -> 805
            };

            const esEscenarioAgentes = this.tipoEscenario === 'agentes';
            escenarios.forEach(e => {
                const intervalo = `${e.intervalo_inicio.slice(0, 5)} - ${e.intervalo_fin.slice(0, 5)}`;
                if (!agrupado[intervalo]) agrupado[intervalo] = { intervalo };

                const diaKeyVolumen = `${e.dia_semana}_vol`;
                const diaKeyTmg = `${e.dia_semana}_tmg`;

                // Limpiamos volumen
                agrupado[intervalo][diaKeyVolumen] = {
                    valor: parsearValorLimpio(e.volumen),
                    id: e.id
                };

                if (!esEscenarioAgentes) {
                    // Limpiamos TMG
                    agrupado[intervalo][diaKeyTmg] = {
                        valor: parsearValorLimpio(e.tmg),
                        id: e.id
                    };
                }

                diasDetectados.add(e.dia_semana);
            });

            const ordenDias = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];

            this.diasMatriz = Array.from(diasDetectados).sort((a, b) => {
                return ordenDias.indexOf(a) - ordenDias.indexOf(b);
            });

            Object.values(agrupado).forEach(row => {
                this.diasMatriz.forEach(dia => {
                    const diaKeyVolumen = `${dia}_vol`;

                    if (!row[diaKeyVolumen]) {
                        row[diaKeyVolumen] = { valor: null, id: null };
                    }
                    if (!esEscenarioAgentes) {
                        const diaKeyTmg = `${dia}_tmg`;
                        if (!row[diaKeyTmg]) {
                            row[diaKeyTmg] = { valor: null, id: null };
                        }
                    }
                });
            });

            this.matrizEscenarios = Object.values(agrupado);

            const headersDinamicos = [];
            const volumenHeaderText = esEscenarioAgentes ? 'Agentes' : 'Vol.';
            this.diasMatriz.forEach(dia => {
                headersDinamicos.push({
                    text: `${volumenHeaderText} (${dia})`,
                    value: `${dia}_vol`,
                    sortable: false
                });
                if (!esEscenarioAgentes) {
                    headersDinamicos.push({
                        text: `TMG (${dia})`,
                        value: `${dia}_tmg`,
                        sortable: false
                    });
                }
            });
            this.headersMatriz = [
                { text: 'Intervalo', value: 'intervalo', sortable: false },
                ...headersDinamicos
            ];
        },
        convertirAHorasEnMinutos(horaStr) {
            const [h, m] = horaStr.split(':').map(Number);
            return h * 60 + m;
        },
        async actualizarCelda(item, claveDinamica) {
            const celda = item[claveDinamica];
            if (!celda || !celda.id) return;

            const tipo = claveDinamica.endsWith('_vol') ? 'volumen' : 'tmg';
            const dia = claveDinamica.split('_')[0];
            const valor = Number(celda.valor);

            if (isNaN(valor) || valor < 0) {
                const nombreCampo = tipo === 'volumen' ? 'Volumen' : 'TMG';
                this.$toast.warning(`❗ El valor de ${nombreCampo} para ${dia} en ${item.intervalo} debe ser un número válido.`);
                return;
            }

            const payload = {
                id: celda.id,
                [tipo]: valor
            };

            const endpoint = tipo === 'volumen' ? 'escenario-actualizar' : 'escenario-tmg-actualizar';

            try {
                await this.$axios.put(endpoint, payload);
                this.$toast.success(`Actualizado ${tipo.toUpperCase()} ${dia} a ${valor} para ${item.intervalo}`);
            } catch (error) {
                console.error(error);
                this.$toast.error('Error al actualizar');
            }
        },
        async actualizarCeldaTMG(item) {
            const tmg = Number(item.tmg);

            if (isNaN(tmg) || tmg < 1) {
                this.$toast.warning(`❗ El valor del TMG para ${item.intervalo} debe ser un número válido y mayor a 0`);
                return;
            }

            const [inicio, fin] = item.intervalo.split(' - ');

            const payload = {
                tmg: tmg,

                servicio_id: this.dialogDetalle.servicio_id,
                nombre: this.dialogDetalle.nombre,
                tipo: this.dialogDetalle.tipo,
                intervalo_inicio: inicio,
                intervalo_fin: fin
            };

            try {
                await this.$axios.put('escenario-tmg-actualizar', payload);
                this.$toast.success(`TMG actualizado a ${tmg} para el intervalo ${item.intervalo} en todos los días.`);
            } catch (error) {
                this.$toast.error('Error al actualizar el TMG');
            }
        },
        pegarDesdeExcel1(e) {
            if (!this.tipoPegado) {
                return;
            }
            const texto = e.clipboardData.getData('text');
            const filas = texto.split('\n').filter(f => f.trim() !== '');
            const columnas = filas.map(f => f.split('\t'));

            const prefijoBuscado = `${this.tipoPegado}_`;

            columnas.forEach((cols, rowIndex) => {
                if (this.intervalos[rowIndex]) {
                    let colIndex = 0;
                    this.headers.forEach((header) => {
                        const key = header.value;
                        if (key === 'texto') {
                            return;
                        }
                        if (key.startsWith(prefijoBuscado)) {
                            const valorPegado = cols[colIndex];

                            if (valorPegado !== undefined) {
                                this.$set(
                                    this.intervalos[rowIndex],
                                    key,
                                    parseFloat(valorPegado) || 0
                                );
                            }
                            colIndex++;
                        }
                    });
                }
            });
        },
        pegarDesdeExcel(e) {
            // 1. Evitamos que se pegue el texto sucio nativo con comas
            e.preventDefault();

            if (!this.tipoPegado) {
                return;
            }

            const texto = e.clipboardData.getData('text');
            const filas = texto.split('\n').filter(f => f.trim() !== '');
            const columnas = filas.map(f => f.split('\t'));

            const prefijoBuscado = `${this.tipoPegado}_`;

            columnas.forEach((cols, rowIndex) => {
                if (this.intervalos[rowIndex]) {
                    let colIndex = 0;
                    this.headers.forEach((header) => {
                        const key = header.value;
                        if (key === 'texto') {
                            return;
                        }
                        if (key.startsWith(prefijoBuscado)) {
                            const valorRaw = cols[colIndex];

                            if (valorRaw !== undefined) {
                                let str = String(valorRaw).trim().replace(',', '.');
                                str = str.replace(/[^0-9.-]/g, '');

                                const valorParseado = parseFloat(str);

                                this.$set(
                                    this.intervalos[rowIndex],
                                    key,
                                    isNaN(valorParseado) ? 0 : valorParseado
                                );
                            }
                            colIndex++;
                        }
                    });
                }
            });

            // 2. Muestra la vista previa del texto procesado dentro del textarea
            if (e.target) {
                // Muestra el texto tal como se copió o formateado
                e.target.value = texto;
            }
        },
        validarEntradaDecimal(item, key, valor) {
            if (valor !== null && valor !== undefined) {
                // Reemplaza comas por puntos en tiempo real
                let strLimpio = String(valor).replace(',', '.');

                // Permite solo números y un único punto
                strLimpio = strLimpio.replace(/[^0-9.]/g, '');

                // Evita múltiples puntos si se ingresa mal
                const partes = strLimpio.split('.');
                if (partes.length > 2) {
                    strLimpio = partes[0] + '.' + partes.slice(1).join('');
                }

                // Actualizamos la propiedad en el objeto
                item[key] = strLimpio;
            } else {
                item[key] = '';
            }
        },
        aplicarTmgGeneral() {
            if (this.tmgGeneral === null || this.tmgGeneral === undefined || this.tmgGeneral < 0) {
                this.$toast.warning('❗ El valor del TMG debe ser un número positivo.');
                return;
            }

            if (!this.intervalos || this.intervalos.length === 0) return;

            const prefijoTMG = "tmg_";

            this.intervalos.forEach((item, rowIndex) => {
                this.headers.forEach((header) => {
                    const key = header.value;

                    if (key.startsWith(prefijoTMG)) {
                        this.$set(
                            this.intervalos[rowIndex],
                            key,
                            parseFloat(this.tmgGeneral) || 0
                        );
                    }
                });
            });

            this.snackbar.text = `Se aplicó TMG de ${this.tmgGeneral} a todos los intervalos.`;
            this.snackbar.visible = true;
            this.tmgGeneral = null;
        },
        obtenerSumaColumna1(columna) {
            if (!this.intervalos || this.intervalos.length === 0) return 0;

            const esTmg = columna.toLowerCase().includes('tmg');

            // Si es una columna normal (como Volumen), hacemos la suma tradicional
            if (!esTmg) {
                let acumulador = 0;
                this.intervalos.forEach(fila => {
                    const valor = parseFloat(fila[columna]);
                    if (!isNaN(valor)) {
                        acumulador += valor;
                    }
                });
                return acumulador;
            }

            // Si es TMG, buscamos su columna de Volumen correspondiente de forma inteligente
            else {
                // Extraemos la parte del día, por ejemplo de "TMG (Lunes)" sacamos "(Lunes)" o "Lunes"
                // O mejor aún: buscamos en los headers cuál es la columna de volumen que le pertenece al mismo índice
                const indexTmg = this.headers.findIndex(h => h.value === columna || h.text === columna);

                // Asumiendo que el Volumen siempre está justo a la izquierda del TMG correspondiente:
                // (Basado en tu imagen: Volumen (Lunes) está en el índice impar y TMG (Lunes) en el par)
                let columnaVolumen = null;
                if (indexTmg > 0) {
                    columnaVolumen = this.headers[indexTmg - 1].value; // o .text según cómo manejes tus headers
                }

                let sumaProductos = 0;
                let sumaVolumenes = 0;

                this.intervalos.forEach(fila => {
                    // Si no encontramos la columna por índice, intentamos construir el nombre exacto buscando la llave en la fila
                    const tmg = parseFloat(fila[columna]);

                    // Buscamos el volumen probando la llave exacta o derivados comunes
                    let valVol = NaN;
                    if (columnaVolumen && !isNaN(parseFloat(fila[columnaVolumen]))) {
                        valVol = parseFloat(fila[columnaVolumen]);
                    } else {
                        // Fallback por si la estructura del texto varía (ej. buscando "Volumen" + el día)
                        const diaMatch = columna.match(/\(([^)]+)\)/); // Extrae lo que está entre paréntesis, ej: "Lunes"
                        if (diaMatch) {
                            const claveVol = Object.keys(fila).find(k => k.toLowerCase().includes('volumen') && k.toLowerCase().includes(diaMatch[1].toLowerCase()));
                            if (claveVol) valVol = parseFloat(fila[claveVol]);
                        }
                    }

                    const volumen = valVol;

                    if (!isNaN(tmg) && !isNaN(volumen)) {
                        sumaProductos += (volumen * tmg);
                        sumaVolumenes += volumen;
                    }
                });

                if (sumaVolumenes === 0) return (0).toFixed(1);

                return (sumaProductos / sumaVolumenes).toFixed(1);
            }
        },

        obtenerSumaColumna(columna) {
            if (!this.intervalos || this.intervalos.length === 0) return 0;

            // Función auxiliar para parsear valores que tengan comas o puntos
            const parsearValor = (val) => {
                if (val === null || val === undefined) return NaN;
                const strVal = String(val).replace(',', '.');
                return parseFloat(strVal);
            };

            const esTmg = columna.toLowerCase().includes('tmg');

            // Si es una columna normal (como Volumen), hacemos la suma tradicional
            if (!esTmg) {
                let acumulador = 0;
                this.intervalos.forEach(fila => {
                    const valor = parsearValor(fila[columna]);
                    if (!isNaN(valor)) {
                        acumulador += valor;
                    }
                });
                return acumulador;
            }

            // Si es TMG, buscamos su columna de Volumen correspondiente
            else {
                const indexTmg = this.headers.findIndex(h => h.value === columna || h.text === columna);

                let columnaVolumen = null;
                if (indexTmg > 0) {
                    columnaVolumen = this.headers[indexTmg - 1].value;
                }

                let sumaProductos = 0;
                let sumaVolumenes = 0;

                this.intervalos.forEach(fila => {
                    const tmg = parsearValor(fila[columna]);

                    let valVol = NaN;
                    if (columnaVolumen && !isNaN(parsearValor(fila[columnaVolumen]))) {
                        valVol = parsearValor(fila[columnaVolumen]);
                    } else {
                        const diaMatch = columna.match(/\(([^)]+)\)/);
                        if (diaMatch) {
                            const claveVol = Object.keys(fila).find(k => k.toLowerCase().includes('volumen') && k.toLowerCase().includes(diaMatch[1].toLowerCase()));
                            if (claveVol) valVol = parsearValor(fila[claveVol]);
                        }
                    }

                    const volumen = valVol;

                    if (!isNaN(tmg) && !isNaN(volumen)) {
                        sumaProductos += (volumen * tmg);
                        sumaVolumenes += volumen;
                    }
                });

                if (sumaVolumenes === 0) return (0).toFixed(1);

                return (sumaProductos / sumaVolumenes).toFixed(1);
            }
        },

        obtenerNumeroSemana(fechaInput) {
            if (!fechaInput) return null;

            const fecha = new Date(fechaInput);
            if (isNaN(fecha.getTime())) return null;

            const d = new Date(Date.UTC(fecha.getFullYear(), fecha.getMonth(), fecha.getDate()));
            const dayNum = d.getUTCDay() || 7;
            d.setUTCDate(d.getUTCDate() + 4 - dayNum);

            const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
            const numeroSemana = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);

            return numeroSemana;
        }

    }
}
export default VolumeTransactions